import { type PreloadedQuery } from "react-relay";
import { type searchableAccountTable_Query } from "@relay/searchableAccountTable_Query.graphql";

export type SearchableAccountTableProps =
	| {
			selection?: SearchableAccountTableSelection;
			onChange?: (selection: SearchableAccountTableSelection) => void;
			selectionMode?: "single";
			excludeAccountIds?: string[];
	  }
	| {
			selection?: SearchableAccountTableSelection[];
			onChange?: (selection: SearchableAccountTableSelection[]) => void;
			selectionMode?: "multiple";
			excludeAccountIds?: string[];
	  };

export type SearchableAccountTableWithPreloadedQueryProps = SearchableAccountTableProps & {
	queryRef: PreloadedQuery<searchableAccountTable_Query>;
};

export type SearchableAccountTableSelection = {
	id: string;
	name: string;
	ownerEmail?: string;
};

export const formatAccountLabel = (name: string, ownerEmail?: string) =>
	ownerEmail ? `${name} (${ownerEmail})` : name;
